module.exports = __webpack_public_path__ + "assets/img/warrior-name-c6a11c07.png";